import { axios } from "@/core/axios";

export interface ContentScheduleItem {
    deadline: string;
    type: string;
    topic: string;
    targetKeyword: string;
}

export async function getContentSchedule(clientId: string | number): Promise<ContentScheduleItem[]> {
    const response = await axios.get<ContentScheduleItem[]>(`/clients/${clientId}/content-schedule`);
    return response.data ?? [];
}
